import React from 'react';
import { Link } from 'react-router-dom';
import { MapPin, Phone, Mail, Facebook, Instagram, Linkedin, Twitter } from 'lucide-react';

export const Footer = () => {
  return (
    <footer className="bg-gray-900 text-gray-300">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {/* Company Info */}
          <div>
            <div className="flex items-center space-x-2 mb-4">
              <img 
                src="/favicon.png" 
                alt="Brainwave Architectural Projects Logo" 
                className="h-12 w-12 object-contain"
              />
              <div>
                <h3 className="text-base font-bold" style={{ color: '#00CED1' }}>BRAINWAVE</h3>
                <p className="text-[10px] tracking-[0.2em]" style={{ color: '#00CED1' }}>ARCHITECTURAL PROJECTS</p>
              </div>
            </div>
            <p className="text-sm text-gray-400 leading-relaxed">
              Transforming visions into architectural masterpieces. Excellence in design, innovation in execution.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-white font-semibold mb-4">Quick Links</h4>
            <ul className="space-y-2">
              <li>
                <Link to="/" className="text-sm hover:text-white transition-colors duration-300" style={{ color: '#00CED1' }}>
                  Home
                </Link>
              </li>
              <li>
                <Link to="/services" className="text-sm hover:text-white transition-colors duration-300" style={{ color: '#00CED1' }}>
                  Services
                </Link>
              </li>
              <li>
                <Link to="/gallery" className="text-sm hover:text-white transition-colors duration-300" style={{ color: '#00CED1' }}>
                  Gallery
                </Link>
              </li>
              <li>
                <Link to="/shop" className="text-sm hover:text-white transition-colors duration-300" style={{ color: '#00CED1' }}>
                  Shop
                </Link>
              </li>
              <li>
                <Link to="/contact" className="text-sm hover:text-white transition-colors duration-300" style={{ color: '#00CED1' }}>
                  Contact
                </Link>
              </li>
              <li>
                <Link to="/track-order" className="text-sm hover:text-white transition-colors duration-300" style={{ color: '#00CED1' }} data-testid="footer-track-order-link">
                  Track Order
                </Link>
              </li>
            </ul>
          </div>

          {/* Services */}
          <div>
            <h4 className="text-white font-semibold mb-4">Our Services</h4>
            <ul className="space-y-2 text-sm text-gray-400">
              <li className="hover:text-white transition-colors duration-300">Architectural Consulting</li>
              <li className="hover:text-white transition-colors duration-300">Design & Planning</li>
              <li className="hover:text-white transition-colors duration-300">Project Management</li>
              <li className="hover:text-white transition-colors duration-300">Custom Furniture</li>
              <li className="hover:text-white transition-colors duration-300">Interior Decor</li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h4 className="text-white font-semibold mb-4">Contact Us</h4>
            <ul className="space-y-3">
              <li className="flex items-start space-x-3">
                <MapPin className="h-5 w-5 mt-0.5 flex-shrink-0" style={{ color: '#00CED1' }} />
                <span className="text-sm text-gray-400">
                  Unit 7, INOspace Tungsten Works<br />
                  7 CR Swart Dr, Strydompark<br />
                  Randburg, 2169
                </span>
              </li>
              <li className="flex items-center space-x-3">
                <Phone className="h-5 w-5 flex-shrink-0" style={{ color: '#00CED1' }} />
                <span className="text-sm text-gray-400">+27 (011) 568 1863</span>
              </li>
              <li className="flex items-center space-x-3">
                <Mail className="h-5 w-5 flex-shrink-0" style={{ color: '#00CED1' }} />
                <span className="text-sm text-gray-400">sales@brainwave-group.com</span>
              </li>
            </ul>

            {/* Social Media */}
            <div className="flex space-x-4 mt-6">
              <a href="#" className="transition-transform duration-300 hover:scale-110" style={{ color: '#00CED1' }}>
                <Facebook className="h-5 w-5" />
              </a>
              <a href="#" className="transition-transform duration-300 hover:scale-110" style={{ color: '#00CED1' }}>
                <Instagram className="h-5 w-5" />
              </a>
              <a href="#" className="transition-transform duration-300 hover:scale-110" style={{ color: '#00CED1' }}>
                <Linkedin className="h-5 w-5" />
              </a>
              <a href="#" className="transition-transform duration-300 hover:scale-110" style={{ color: '#00CED1' }}>
                <Twitter className="h-5 w-5" />
              </a>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-gray-800 mt-8 pt-8 text-center">
          <p className="text-sm text-gray-500">
            &copy; {new Date().getFullYear()} Brainwave Architectural Projects. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
};
